export const USER_HAS_NOT_PERMISSION_TO_RESEND_EMAIL = 'You do not have permission to resend emails.';

export const EMAIL_MISSING_INVOICE_ID = 'This email is missing the Invoice Id, this is a data mapping issue that we\'re working to fix!';
